import * as async from 'async';
const logger = console;
export class SearchResultsProcessor {
    /**
     * process search results asynchronously in parallel. This should be used when processing order is not important
     * @param results
     * @param elementProcessingCallback
     * @param completionCallback
     */
    static processSearchResultsParallel(results, elementProcessingCallback, completionCallback) {
        SearchResultsProcessor.process(async.each, results, elementProcessingCallback, completionCallback);
    }
    /**
     * process search results asynchronously in series. This should be used when processing order is important
     * @param results
     * @param elementProcessingCallback
     * @param completionCallback
     */
    static processSearchResults(results, elementProcessingCallback, completionCallback) {
        SearchResultsProcessor.process(async.eachSeries, results, elementProcessingCallback, completionCallback);
    }
    /**
     *
     * @param processingFunction - the function from the async package that will be used to process the results
     * @param results
     * @param elementProcessingCallback
     * @param completionCallback
     */
    static process(processingFunction, results, elementProcessingCallback, completionCallback) {
        const docs = [];
        const isOtherSearch = (results.searchProvier && results.searchProvier !== 'elastic');
        let resultDocs;
        let totalHits = 0;
        let lastSort;
        if (isOtherSearch) {
            resultDocs = results.data;
            totalHits = results.total ? results.total : results.data.length;
        }
        else {
            resultDocs = results.data.hits.hits;
            totalHits = results.data.hits.total;
            if (resultDocs.length > 0) {
                const lastDoc = resultDocs[resultDocs.length - 1];
                if (lastDoc.sort) {
                    lastSort = lastDoc.sort;
                }
            }
        }
        processingFunction(resultDocs, function (hit, next) {
            let doc;
            let sort;
            if (isOtherSearch) {
                // if alias is not given in the select statement, then the result enclosed with bucketName / db Name.
                const objKeys = Object.keys(hit);
                if (objKeys.length <= 1 && results.dbName === objKeys[0]) {
                    delete hit[objKeys[0]].total_hits;
                    doc = hit[objKeys[0]];
                }
                else {
                    delete hit.total_hits;
                    doc = hit;
                }
            }
            else {
                doc = hit._source;
                sort = hit.sort;
            }
            elementProcessingCallback(doc, sort);
            docs.push(doc);
            next();
        }, function (err) {
            if (err) {
                logger.error('Error in processing search results : ' + JSON.stringify(err));
            }
            completionCallback(docs, totalHits, lastSort);
        });
    }
}
